import { inject, Injectable } from '@angular/core';
import { parse } from 'tinyduration';
import { DurationUnitEnum } from '@lx/shared/data-access/types';
import { DurationUnitsService } from '@lx/shared/utils/services';

type TinyDurationUnitEnum = 'YEARS' | 'MONTH' | 'WEEKS' | 'DAYS';
const TinyDurationUnitEnum = {
  weeks: 'WEEKS' as TinyDurationUnitEnum,
  months: 'MONTH' as TinyDurationUnitEnum,
  days: 'DAYS' as TinyDurationUnitEnum,
  years: 'YEARS' as TinyDurationUnitEnum,
};

@Injectable({
  providedIn: 'root',
})
export class DepositService {
  private localizedAnd = $localize`and`;
  private durationUnitsService = inject(DurationUnitsService);

  getDepositRequiredMessage(depositRequiredThreshold: string): string {
    if (!depositRequiredThreshold) {
      return null;
    }

    try {
      const parsedDepositRequiredThreshold = parse(depositRequiredThreshold);
      const localizedThreshold = Object.keys(parsedDepositRequiredThreshold).map((k) =>
        this.durationUnitsService.getDurationText(parsedDepositRequiredThreshold[k], DurationUnitEnum[TinyDurationUnitEnum[k]]),
      );
      return localizedThreshold.join(', ').replace(/, ([^,]*)$/, ` ${this.localizedAnd} $1`);
    } catch (e) {
      // only warn: the value can be a non-parseable duration (e.g. REQUIRED) and we don't want to break the app
      console.warn('Deposit required threshold is not parseable:', e);
      return null;
    }
  }
}
